// extracted by mini-css-extract-plugin
export var brand = "_47-9";
export var compact = "_47-6";
export var extraSmall = "_47-7";
export var icon = "_47-0";
export var large = "_47-4";
export var light = "_47-1";
export var medium = "_47-5";
export var outline = "_47-b";
export var primaryDark = "_47-a";
export var primaryLight = "_47-8";
export var primaryModern = "_47-c";
export var success = "_47-2";
export var successSolid = "_47-3";